<template>
  <loading-component v-if="isLoading"/>
  <div class="columns is-multiline" v-else>
    <div class="column is-12 is-paddingless is-marginless has-text-left titleCard is-flex">
      <div>
        {{ detail.productName }} ({{ detail.name }}) -
        <span class="tag" :class="[
          detail.statusName == 'Pendiente' ? 'is-info' : '',
          detail.statusName == 'Preaprobado' ? 'is-warning' : '',
          detail.statusName == 'Activo' ? 'is-success' : '',
        ]">{{ detail.statusName }}</span>
      </div>
    </div>

    <div class="column is-12 separator"></div>

    <div class="column is-6">
      <div class="is-flex is-flex-direction-column gap">
        <div class="box">
          <h3 class="title is-5">Datos de Dirección</h3>
          <p><strong>Calle:</strong> {{ data.street }}</p>
          <p><strong>Número externo:</strong> {{ data.external_number }}</p>
          <p><strong>Número interno:</strong> {{ data.internal_number || 'N/A' }}</p>
          <p><strong>Colonia:</strong> {{ data.colony }}</p>
          <p><strong>Ciudad:</strong> {{ data.city }}</p>
          <p><strong>Estado:</strong> {{ data.state }}</p>
          <p><strong>Código postal:</strong> {{ data.postal_code }}</p>
          <!-- <p><strong>Latitud:</strong> {{ data.latitude || 'N/A' }}</p> -->
          <!-- <p><strong>Longitud:</strong> {{ data.longitude || 'N/A' }}</p> -->
        </div>
        <div class="box">
          <h3 class="title is-5">Información General</h3>
          <p><strong>Producto ID:</strong> {{ data.product_id }}</p>
          <p><strong>Usuario ID:</strong> {{ data.user_id }}</p>
          <p><strong>Creado el:</strong> {{ formatDate(data.created_at) }}</p>
          <p><strong>Actualizado el:</strong> {{ formatDate(data.updated_at) }}</p>
        </div>
      </div>
    </div>

    <div class="column is-6">
      <div class="is-flex is-flex-direction-column gap">
        <div class="box">
          <h3 class="title is-5">Datos de Envío</h3>
          <p><strong>Número de Guía (Tracking):</strong> {{ data.tracking_number || 'N/A' }}</p>
          <p><strong>Estado de envío:</strong>
            <span v-if="data.dhl_status === 'SUCCESS'" class="has-text-success">{{ data.dhl_status }}</span>
            <span v-else>{{ data.dhl_status || 'N/A' }}</span>
          </p>
          <p><strong>Seguro de envío:</strong> {{ data.shipping_insurance ? 'Sí' : 'No' }}</p>
          <p><strong>URL Guía:</strong>
            <a v-if="data.label_url" :href="data.label_url" target="_blank" class="has-text-link">Descargar PDF</a>
            <span v-else>N/A</span>
          </p>
          <p><strong>QR Generado el:</strong> {{ formatDate(data.qr_generated_at) }}</p>
          <p><strong>Enviado el:</strong> {{ formatDate(data.shipped_at) }}</p>
        </div>
        <!-- <div class="box"> -->
          <!-- Funcionalidad anterior comentada:
          <div class="field">
            <input
              id="qrGeneratedStatus"
              type="checkbox"
              class="switch is-rounded is-info"
              v-model="data.qr_generated_at"
              @change="updateStatus('qr_generated_at', data.qr_generated_at)"
            >
            <label for="qrGeneratedStatus">Guía DHL Generada</label>
          </div>

          <div class="field">
            <input
              id="shippedStatus"
              type="checkbox"
              class="switch is-rounded is-info"
              v-model="data.shipped_at"
              @change="updateStatus('shipped_at', data.shipped_at)"
            >
            <label for="shippedStatus">Usuario Envió el Producto</label>
          </div>
          -->
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    detail: {
      type: Object,
      required: true
    }
  },
  components: {
    LoadingComponent: () => import('@/components/ui/Loading')
  },
  data () {
    return {
      isLoading: false,
      data: {}
    }
  },
  methods: {
    ...mapActions(['getAdminDelivery', 'updateAdminDeliveryStatus']),

    formatDate (date) {
      return date ? new Date(date).toLocaleString() : 'Sin información'
    },

    async updateStatus (field, value) {
      try {
        await this.updateAdminDeliveryStatus({
          deliveryId: this.detail.dhl_delivery_id,
          field,
          value
        })
      } catch (error) {
        console.error('Error actualizando estado:', error)
      }
    }
  },

  async beforeMount () {
    this.isLoading = true

    let response = await this.getAdminDelivery({ deliveryId: this.detail.dhl_delivery_id })

    this.data = response

    this.isLoading = false
  }
}
</script>

<style>
.is-flex-direction-column {
  flex-direction: column;
}
.gap {
  gap: 10px;
}
</style>
